import useContainerDimensions from "utils/useContainerDimensions";

/** scale up the children using css transform: scale(x),
 * where x = currentWidth / baseWidth */
export function ScaleWithWidth({
  children,
  baseWidth,
  transformOrigin,
  scaleMultiplier = 1,
  style = {},
  enable = true,
  upOnly = true,
  className,
  transformTranslate = "0px, 0px",
}: {
  children: React.ReactNode;
  /** scale up/down relative to this width (px) e.g. 1200px container width / 1000px baseWidth = 1.2x scale */
  baseWidth: number;
  transformOrigin: string;
  /** scale up/down by this multiplier */
  scaleMultiplier?: number;
  style?: React.CSSProperties;
  enable?: boolean;
  /** only scale up, not down */
  upOnly?: boolean;
  className?: string;
  transformTranslate?: string | null;
}) {
  const [ref, { width }] = useContainerDimensions();
  const scale =
    width / baseWidth < 1 && upOnly ? 1 : (width / baseWidth) * scaleMultiplier;
  const scaleClamped = upOnly ? Math.max(1, scale) : scale;
  return enable ? (
    <div
      className={`scaleWithWidth ${className ?? ""}`}
      ref={ref}
      style={{
        width: "100%",
        height: "100%",
        transform: `scale(${scaleClamped}) translate(${transformTranslate})`,
        transformOrigin,

        ...style,
      }}
    >
      {children}
    </div>
  ) : (
    <>{children}</>
  );
}
